<template>
  <div class="fluid" id="formTemplateList">
    <div>
      <div class="form-template-list-div">
        <v-card elevation="0" class="px-3 py-2" style="width: 100%">
          <v-row>
            <v-col
              cols="12"
              class="d-flex"
              style="
                position: relative;
                padding: 0 20px;
                text-align: center;
                margin-top: 20px;
              "
            >
              <h4 class="indigo--text" style="font-weight: bold; margin: auto">
                MASTER TEMPLATE FORMULIR
                <v-tooltip bottom color="grey">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      x-small
                      text
                      icon
                      color="grey darken-2"
                      @click="getDataFromApi"
                    >
                      <v-icon small>mdi-refresh</v-icon>
                    </v-btn>
                  </template>
                  <span>refresh page</span>
                </v-tooltip>
              </h4>
            </v-col>
            <v-col cols="12">
              <div>
                <v-toolbar
                  class="group-list-toolbar-1"
                  flat
                  style="
                    height: 60px;
                    border-radius: 10px 10px 0 0;
                    padding-top: 15px;
                  "
                >
                  <div class="d-flex align-content-start">
                    <div
                      style="margin-right: 15px; height: 45px"
                      class="d-flex justify-center align-center"
                    >
                      <v-btn
                        style="font-size: 12px"
                        @click="addTemplate"
                        elevation="2"
                        tilerounded="5px"
                        color="primary"
                        class="white--text"
                        small
                      >
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon v-bind="attrs" v-on="on" small class="">
                              mdi-plus
                            </v-icon>
                          </template>
                          <span>Add Template</span>
                        </v-tooltip>
                      </v-btn>
                    </div>
                  </div>
                  <div style="width: 210px; height: 45px">
                    <v-autocomplete
                      v-model="paramAPI.company_id"
                      label="Perusahaan"
                      item-text="name"
                      item-value="id"
                      return-id
                      dense
                      outlined
                      clearable
                      @change="companyWatcher"
                      :items="dropdown.company"
                      :disabled="isDisableCompanyDropdown"
                    ></v-autocomplete>
                  </div>
                  <div style="width: 180px; height: 45px; margin-left: 15px">
                    <v-autocomplete
                      v-model="paramAPI.audit_type_id"
                      label="Audit Type"
                      item-text="name"
                      item-value="id"
                      return-id
                      dense
                      outlined
                      clearable
                      @change="auditTypeWatcher"
                      :items="dropdown.auditType"
                    ></v-autocomplete>
                  </div>
                  <div style="width: 30%; margin-left: auto; margin-top: 20px">
                    <v-text-field
                      v-model="paramAPI.keyword"
                      @keyup.enter="searchEnter"
                      label="Search here"
                      type="search"
                      append-icon="mdi-magnify"
                      outlined
                      dense
                    ></v-text-field>
                  </div>
                </v-toolbar>
              </div>
            </v-col>

            <v-col cols="12" style="width: 100%">
              <v-data-table
                v-if="result.length > 0 || !skeleton_loading"
                mobile-breakpoint="0"
                fixed-header
                height="50vh"
                :headers="headers"
                style="cursor: pointer"
                :items="result"
                :loading="loading"
                @click:row="rowClick"
                item-key="id"
                :options.sync="options"
                :footer-props="{
                  showFirstLastPage: true,
                  showCurrentPage: true,
                  itemsPerPageOptions: [1, 3, 5, 10, 15, 100]
                }"
                :server-items-length="totalData"
                :page="paramAPI.page"
                @update:page="updatePage"
                :items-per-page="paramAPI.itemsPerPage"
                @update:items-per-page="updateItemPerPage"
              >
                <template v-slot:[`item.no`]="{ index }">
                  <div
                    style="
                      font-size: 14px;
                      padding: 0;
                      display: flex;
                      flex-direction: row;
                    "
                  >
                    {{ index + 1 + paramAPI.offset * paramAPI.limit }}
                  </div>
                </template>
                <template v-slot:[`item.name`]="{ item }">
                  <div
                    style="
                      font-size: 14px;
                      padding: 0;
                      display: flex;
                      flex-direction: row;
                      color: green;
                    "
                  >
                    {{ item.name }}
                  </div>
                </template>
                <template v-slot:[`item.company_name`]="{ item }">
                  <div
                    style="
                      width: 120px;
                      font-size: 12px;
                      padding: 0;
                      display: flex;
                      flex-direction: row;
                    "
                  >
                    {{ item.company_name }}
                  </div>
                </template>
                <template v-slot:[`item.department_name`]="{ item }">
                  <div
                    style="
                      width: 120px;
                      font-size: 12px;
                      padding: 0;
                      display: flex;
                      flex-direction: row;
                    "
                  >
                    {{ item.department_name }}
                  </div>
                </template>
                <template v-slot:[`item.audit_type`]="{ item }">
                  <div
                    style="
                      width: 120px;
                      font-size: 12px;
                      padding: 0;
                      display: flex;
                      flex-direction: row;
                    "
                  >
                    {{ item.audit_type != null ? item.audit_type.name : '' }}
                  </div>
                </template>
                <template v-slot:[`item.createdAt`]="{ item }">
                  <div
                    style="
                      width: 80px;
                      font-size: 12px;
                      padding: 0;
                      display: flex;
                      flex-direction: row;
                    "
                  >
                    {{ convertDate(item.createdAt) }}
                  </div>
                </template>
                <template v-slot:[`item.updatedAt`]="{ item }">
                  <div
                    style="
                      width: 80px;
                      font-size: 12px;
                      padding: 0;
                      display: flex;
                      flex-direction: row;
                    "
                  >
                    {{ convertDate(item.updatedAt) }}
                  </div>
                </template>
                <template v-slot:[`item.action`]="{ item }">
                  <v-tooltip left>
                    <template v-slot:activator="{ on, attrs }"
                      ><v-icon
                        v-bind="attrs"
                        v-on="on"
                        @click.stop="rowClick(item)"
                        small
                        color="primary"
                        class="mr-2"
                      >
                        mdi-pencil
                      </v-icon>
                    </template>
                    <span>Edit</span>
                  </v-tooltip>
                  <v-tooltip right>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        v-bind="attrs"
                        v-on="on"
                        small
                        color="error"
                        @click.stop="deleteItem(item)"
                      >
                        mdi-delete
                      </v-icon>
                    </template>
                    <span>Delete</span>
                  </v-tooltip>
                </template>
              </v-data-table>
              <v-skeleton-loader
                v-else
                style="width: 100%"
                type="table-heading, table-tbody, table-tfoot"
              ></v-skeleton-loader>
            </v-col>
          </v-row>
        </v-card>
      </div>
    </div>
    <v-dialog
      v-model="formTemplate"
      persistent
      :fullscreen="dialogFullscreen"
      :max-width="500"
    >
      <v-card v-if="form !== null">
        <v-card-title>
          <p class="text-h5 text-center text-uppercase" style="margin: auto">
            {{ form.act == 'update' ? 'Detail ' : 'Add ' }}Template
          </p>
        </v-card-title>
        <v-card-text>
          <v-form ref="entryForm2" @submit.prevent="saveForm">
            <v-container>
              <v-row>
                <v-col cols="12" class="d-flex flex-column">
                  <p
                    class="text-left"
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    Nama Template
                  </p>
                  <v-text-field
                    v-model="form.name"
                    :rules="rules.nameRules"
                    dense
                    outlined
                    style="height: 45px"
                  />
                </v-col>
                <v-col
                  cols="12"
                  :md="form.act == 'update' ? 8 : 12"
                  class="d-flex flex-column"
                >
                  <p
                    class="text-left"
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    Perusahaan
                  </p>
                  <v-autocomplete
                    v-model="form.company"
                    :items="dropdown.company"
                    :rules="rules.companyRules"
                    item-text="name"
                    item-value="id"
                    return-object
                    dense
                    outlined
                    clearable
                    style="height: 45px"
                  ></v-autocomplete>
                </v-col>
                <v-col
                  cols="12"
                  :md="form.act == 'update' ? 4 : 12"
                  class="d-flex flex-column"
                >
                  <p
                    class="text-left"
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    Tipe Audit
                  </p>
                  <v-autocomplete
                    v-model="form.audit_type_id"
                    :items="dropdown.auditType"
                    :rules="rules.typeRules"
                    item-text="name"
                    item-value="id"
                    return-id
                    dense
                    outlined
                    clearable
                  ></v-autocomplete>
                </v-col>
              </v-row>
            </v-container>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                style="position: absolute; top: 10px; right: 10px"
                fab
                icon
                x-small
                outlined
                @click="closeformTemplate"
              >
                <v-icon size="30" color="red">mdi-close</v-icon>
              </v-btn>
              <!-- <v-btn
                v-if="!isEdit"
                color="blue darken-1"
                type="button"
                small
                class="white--text"
                @click="enableEdit"
              >
                Edit Header
              </v-btn> -->
              <div style="width: 100%">
                <!-- <v-btn
                  color="red darken-1"
                  type="button"
                  small
                  class="white--text mr-3"
                  @click="enableEdit"
                >
                  Cancel
                </v-btn> -->
                <v-btn
                  color="blue darken-1"
                  small
                  class="white--text"
                  type="submit"
                  style="width: 100%"
                >
                  Save
                </v-btn>
              </div>
            </v-card-actions>
            <v-divider v-if="form.act == 'update'"></v-divider>
          </v-form>
        </v-card-text>
        <v-card-text v-if="form.act == 'update'">
          <v-btn
            v-if="!isEdit"
            color="blue darken-1"
            type="button"
            small
            class="white--text"
            style="position: relative; top: -10px; left: 10px"
            @click="addClause"
          >
            + Add Item
          </v-btn>
          <v-card>
            <v-data-table
              fixed-header
              mobile-breakpoint="0"
              height="50vh"
              item-key="id"
              style="cursor: pointer"
              elevation="1"
              :headers="clauseHeaders"
              :items="clauseDetail"
              :loading="loading"
              @click:row="clauseRowClick"
              :footer-props="{
                showFirstLastPage: true,
                showCurrentPage: true,
                itemsPerPageOptions: [1, 3, 5, 10, 15, 100]
              }"
            >
              <template v-slot:[`item.no`]="{ index }">
                <div
                  style="
                    font-size: 14px;
                    padding: 0;
                    display: flex;
                    flex-direction: row;
                  "
                >
                  {{ index + 1 + paramAPI.offset * paramAPI.limit }}
                </div>
              </template>
              <template v-slot:[`item.clause_desc`]="{ item }">
                <div
                  style="
                    width: 210px;
                    font-size: 14px;
                    padding: 0;
                    display: flex;
                    flex-direction: row;
                    color: green;
                  "
                >
                  {{ item.clause_desc }}
                </div>
              </template>
              <template v-slot:[`item.clause_no`]="{ item }">
                <div
                  style="
                    width: 120px;
                    font-size: 14px;
                    padding: 0;
                    display: flex;
                    flex-direction: row;
                  "
                >
                  {{ item.clause_no }}
                </div>
              </template>
              <template v-slot:[`item.clause_category_name`]="{ item }">
                <div
                  style="
                    width: 160px;
                    font-size: 14px;
                    padding: 0;
                    display: flex;
                    flex-direction: row;
                  "
                >
                  {{ item.clause_category_name }}
                </div>
              </template>
              <template v-slot:[`item.clause_ref`]="{ item }">
                <div
                  style="
                    width: 120px;
                    font-size: 14px;
                    padding: 0;
                    display: flex;
                    flex-direction: row;
                  "
                >
                  {{ item.clause_ref }}
                </div>
              </template>
              <template v-slot:[`item.area`]="{ item }">
                <div
                  style="
                    width: 120px;
                    font-size: 12px;
                    padding: 0;
                    display: flex;
                    flex-direction: row;
                  "
                >
                  {{ item.area != null ? item.area.name : null }}
                </div>
              </template>
              <template v-slot:[`item.scope`]="{ item }">
                <div
                  style="
                    width: 120px;
                    font-size: 12px;
                    padding: 0;
                    display: flex;
                    flex-direction: row;
                  "
                >
                  {{ item.scope != null ? item.scope.name : null }}
                </div>
              </template>

              <template v-slot:[`item.action`]="{ item }">
                <v-tooltip left>
                  <template v-slot:activator="{ on, attrs }"
                    ><v-icon
                      v-bind="attrs"
                      v-on="on"
                      @click.stop="clauseRowClick(item)"
                      small
                      color="primary"
                      class="mr-2"
                    >
                      mdi-pencil
                    </v-icon>
                  </template>
                  <span>Edit</span>
                </v-tooltip>
                <v-tooltip right>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      v-bind="attrs"
                      v-on="on"
                      small
                      color="error"
                      @click.stop="clauseDeleteItem(item)"
                    >
                      mdi-delete
                    </v-icon>
                  </template>
                  <span>Delete</span>
                </v-tooltip>
              </template>
            </v-data-table>
          </v-card>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import axios from 'axios'
import { mapGetters, mapMutations /* ,  mapActions */ } from 'vuex'
import buildType from '../../../services/buildType'
export default {
  name: 'formTemplate',
  data: () => ({
    editDialog: false,
    formTemplate: false,
    formClause: false,
    dialogFullscreen: false,
    dssApi: buildType.apiURL('dss'),
    eSanqua: buildType.apiURL('esanqua'),
    build: process.env.VUE_APP_BUILD_TYPE,
    paramAPI: {
      page: 1,
      keyword: '',
      offset: 0,
      limit: 10,
      itemsPerPage: 10,
      sortBy: 'date',
      sortType: 'desc',
      company_id: null,
      audit_type_id: null
      // department_id: null
    },
    totalData: 0,
    form: null,
    isEdit: false,
    actionValue: 0,
    loading: false,
    isDisableCompanyDropdown: false,
    skeleton_loading: true,
    options: {},
    result: [],
    clauseDetail: [],
    rules: {
      nameRules: [],
      companyRules: [],
      auditTypeRules: []
    },
    dropdown: {
      company: [],
      auditType: [],
      department: []
    }
  }),

  async mounted() {
    this.paramAPI.company_id = Number(
      this.getUserProfile.employee.company.plant_id
    )
    this.paramAPI.department_id = this.getUserProfile.employee.department_id
    if (this.getFormTemplatePageQuery !== null) {
      this.paramAPI = this.getFormTemplatePageQuery
    }
    setTimeout(async () => {
      await this.getDataFromApi()
      await this.initDropdown()
    }, 200)
  },
  computed: {
    ...mapGetters(['getUserProfile', 'getFormTemplatePageQuery']),
    headers() {
      const arrHeaders = [
        {
          text: 'No',
          value: 'no',
          align: 'left',
          sortable: false
        },
        {
          text: 'Name',
          value: 'name',
          align: 'left',
          sortable: false
        },
        {
          text: 'Company',
          value: 'company_name',
          align: 'left',
          sortable: false
        },
        {
          text: 'Audit Type',
          value: 'audit_type',
          align: 'left',
          sortable: false
        },
        {
          text: 'Created at',
          value: 'createdAt',
          align: 'left',
          sortable: false
        },
        {
          text: 'Updated at',
          value: 'updatedAt',
          align: 'left',
          sortable: false
        },
        {
          text: 'Actions',
          value: 'action',
          align: 'left',
          sortable: false
        }
      ]
      return arrHeaders
    },
    clauseHeaders() {
      const arrClauseHeaders = [
        {
          text: 'No',
          value: 'no',
          align: 'left',
          sortable: false
        },
        {
          text: 'Kategori',
          value: 'clause_category_name',
          align: 'left',
          sortable: false
        },
        {
          text: 'Klausul',
          value: 'clause_desc',
          align: 'left',
          sortable: false
        },
        {
          text: 'No Klausul',
          value: 'clause_no',
          align: 'left',
          sortable: false
        },
        {
          text: 'Ref',
          value: 'clause_ref',
          align: 'left',
          sortable: false
        },
        {
          text: 'Area',
          value: 'area',
          align: 'left',
          sortable: false
        },
        {
          text: 'Scope',
          value: 'scope',
          align: 'left',
          sortable: false
        },
        {
          text: 'Actions',
          value: 'action',
          align: 'left',
          sortable: false
        }
      ]
      return arrClauseHeaders
    }
  },
  watch: {},
  methods: {
    // ...mapActions(['dropdownPlant']),
    ...mapMutations(['setFormTemplatePageQuery']),
    showMsgDialog(pModalType, pStatusMsg, pBtnCancel) {
      return new Promise((resolve) => {
        this.$swal
          .fire({
            position: 'center',
            icon: pModalType,
            html: '<strong style="font-size:18px;">' + pStatusMsg + '</strong>',
            showConfirmButton: true,
            showCancelButton: pBtnCancel,
            cancelButtonText: 'No'
          })
          .then((r) => {
            resolve(r)
          })
      })
    },
    async initDropdown() {
      this.dropdownCompany()
      this.dropdownAuditType()
      // this.dropdownDepartment()
    },
    resetSomeParam() {
      this.paramAPI.limit = this.paramAPI.itemsPerPage
      this.paramAPI.offset = 0
      this.paramAPI.page = 1
    },
    searchEnter() {
      this.resetSomeParam()
      this.getDataFromApi()
    },
    companyWatcher() {
      this.resetSomeParam()
      this.getDataFromApi()
    },
    auditTypeWatcher() {
      this.resetSomeParam()
      this.getDataFromApi()
    },

    async dropdownCompany() {
      const level = this.getUserProfile.level.find(
        ({ id }) => id === '1' || id === '39'
      )
      let xFlag = false
      if (level !== undefined) {
        if (level.user_user_level !== null) {
          if (
            level.user_user_level.allowed_company === null ||
            level.user_user_level.allowed_company.length === 0
          ) {
            xFlag = true
          } else {
            this.dropdown.company = level.user_user_level.allowed_company
            this.isDisableCompanyDropdown = false
          }
        } else {
          xFlag = true
        }
      } else {
        xFlag = true
      }

      if (xFlag) {
        if (Number(this.getUserProfile.employee.company.plant_id) !== 6) {
          this.isDisableCompanyDropdown = true
        } else {
          this.isDisableCompanyDropdown = false
        }
        axios
          .get(`${this.eSanqua}master/universal/plant/dropdown`)
          .then((res) => {
            this.dropdown.company = res.data.data
          })
          .catch((err) => {
            console.log(err)
          })
      }
    },

    async dropdownAuditType() {
      await axios
        .get(`${this.dssApi}master/universal/audittype/dropdown`)
        .then((res) => {
          if (res.data.status_code === '00') {
            return (this.dropdown.auditType = res.data.data)
          }
          return (this.dropdown.auditType = [])
        })
        .catch((err) => {
          console.log(err)
          return (this.dropdown.auditType = [])
        })
    },

    async getDataFromApi() {
      this.loading = true
      await this.initDataTable()
        .then((data) => {
          if (data.status_code === '00') {
            this.totalData = data.total_record
            return (this.result = data.data)
          }
          return (this.result = [])
        })
        .catch((err) => {
          console.log(err)
          return (this.result = [])
        })
      this.skeleton_loading = false
      this.loading = false
    },
    async initDataTable() {
      let url = `${this.dssApi}master/universal/formtemplate/list?keyword=${
        this.paramAPI.keyword
      }&offset=${this.paramAPI.offset * this.paramAPI.limit}&limit=${
        this.paramAPI.limit
      }&join_table=[{"name":"audittype","alias":"audit_type"}]`
      const filter = []
      if (this.paramAPI.company_id !== null) {
        filter.push(`{"company_id": ${this.paramAPI.company_id}}`)
      }
      if (this.paramAPI.audit_type_id !== null) {
        filter.push(`{"audit_type_id": ${this.paramAPI.audit_type_id}}`)
      }
      url = url + `&filter=[${filter}]`
      this.setFormTemplatePageQuery(this.paramAPI)
      return await new Promise((resolve) => {
        axios
          .get(url)
          .then((res) => {
            console.log(res)
            resolve(res.data)
          })
          .catch((err) => {
            console.log(err)
          })
      })
    },
    enableEdit() {
      var oldForm = this.form
      this.isEdit = !this.isEdit
      if (!this.isEdit) {
        this.form = oldForm
        // if (this.form.act === 'add') {
        //   this.closeDialog()
        // }
      }
    },

    rowClick(pItem) {
      // let xCompany = null
      // if (pItem.company_id !== null) {
      //   xCompany = {
      //     id: pItem.company_id,
      //     name: pItem.company_name
      //   }
      // }
      // let xDepartment = null
      // if (pItem.department_id !== null) {
      //   xDepartment = {
      //     id: pItem.department_id,
      //     name: pItem.department_name
      //   }
      // }
      // this.form = {
      //   act: 'update',
      //   id: pItem.id,
      //   name: pItem.name,
      //   company: xCompany,
      //   deparment: xDepartment,
      //   audit_type_id: pItem.audit_type_id
      // }
      // this.dialogFullscreen = true
      // this.getTemplateItem(pItem.id)

      setTimeout(() => {
        this.$router.push(`formtemplate/detail/${pItem.id}`)
      }, 100)
    },
    async deleteItem(pItem) {
      this.showMsgDialog(
        'question',
        'Are you sure, This data will be deleted permanently',
        true
      ).then(async (res) => {
        if (res.isConfirmed) {
          await axios
            .delete(
              `${this.dssApi}master/universal/formtemplate/delete/${pItem.id}`
            )
            .then(async (res) => {
              if (res.data.status_code !== '-99') {
                this.showMsgDialog('success', res.data.status_msg, false)
                this.getDataFromApi()
              } else {
                this.showMsgDialog('warning', res.data.status_msg, false)
              }
            })
            .catch((err) => {
              console.log(err)
              this.showMsgDialog(
                'error',
                err
                  ? 'Something went wrong, Please contact an admin!'
                  : 'Something went wrong, Please contact an admin!',
                false
              )
            })
        }
      })
    },
    // closeDialog() {
    //   this.form = null
    //   this.isEdit = false
    //   setTimeout(() => {
    //     this.editDialog = false
    //   }, 300)
    // },
    addTemplate() {
      this.form = {
        act: 'add',
        name: null,
        company: null,
        department: null,
        audit_type_id: null
      }
      setTimeout(() => {
        this.formTemplate = !this.formTemplate
      }, 300)
    },
    saveForm() {
      this.rules.nameRules = [(v) => !!v || 'Name is required']
      this.rules.companyRules = [(v) => !!v || 'Company is required']
      this.rules.auditTypeRules = [(v) => !!v || 'Audit Type is required']

      const self = this
      setTimeout(function () {
        if (self.$refs.entryForm2.validate()) {
          const form = {
            act: self.form.act,
            name: self.form.name,
            company_id: self.form.company.id,
            company_name: self.form.company.name,
            audit_type_id: self.form.audit_type_id
          }

          if (self.form.department != null) {
            Object.assign(form, {
              department_id: self.form.department.id,
              department_name: self.form.department.name
            })
          }

          if (form.act === 'update') {
            Object.assign(form, { id: self.form.id })
          }

          self.submitAuditType(form)
        }
      })
    },
    async submitAuditType(form) {
      console.log(form)
      await axios
        .post(`${this.dssApi}master/universal/formtemplate/save`, form)
        .then(async (res) => {
          console.log(res.data)
          if (res.data.status_code == '00') {
            this.showMsgDialog('success', res.data.status_msg, false)
            this.getDataFromApi()
            this.closeformTemplate()
            setTimeout(() => {
              this.$router.push(`formtemplate/detail/${res.data.created_id}`)
            }, 100)
          } else {
            if (res.data.status_msg === 'Parameter value has problem') {
              this.showMsgDialog(
                'warning',
                'Invalid input, Parameter value has problem',
                false
              )
            } else {
              this.showMsgDialog('warning', res.data.status_msg, false)
            }
          }
        })
        .catch((err) => {
          console.log(err)
          this.showMsgDialog(
            'error',
            err
              ? 'Something went wrong, Please contact an admin!'
              : 'Something went wrong, Please contact an admin!',
            false
          )
        })
    },
    closeformTemplate() {
      this.formTemplate = false
      setTimeout(() => {
        this.form = null
        this.clauseDetail = []
        this.isEdit = false
        this.dialogFullscreen = false
      }, 300)
    },
    addClause() {
      console.log('add clause')

      // this.form = {
      //   act: 'add'
      // }
      // setTimeout(() => {
      //   this.formClause = !this.formClause
      // }, 300)
    },
    clauseRowClick() {
      console.log('edit clause')
    },
    async getTemplateItem(pItemId) {
      const url = `${this.dssApi}formtemplate/detail/${pItemId}`

      axios
        .get(url)
        .then((res) => {
          // console.log(res)
          if (res.data.status_code == '00') {
            const formTemplatItem = res.data.data.form_template_item
            const newArrItem = []
            if (formTemplatItem.length > 0) {
              for (let i = 0; i < formTemplatItem.length; i++) {
                var objItem = {
                  id: formTemplatItem[i].id,
                  clause_id: formTemplatItem[i].clause.id,
                  clause_desc: formTemplatItem[i].clause.description,
                  clause_no: formTemplatItem[i].clause.clause_no,
                  clause_ref: formTemplatItem[i].clause.reference,
                  clause_category_id:
                    formTemplatItem[i].clause.clause_category != null
                      ? formTemplatItem[i].clause.clause_category.id
                      : null,
                  clause_category_name:
                    formTemplatItem[i].clause.clause_category != null
                      ? formTemplatItem[i].clause.clause_category.name
                      : null,
                  area: formTemplatItem[i].area,
                  scope: formTemplatItem[i].scope
                }
                newArrItem.push(objItem)
              }
            }
            console.log(newArrItem)
            this.clauseDetail = newArrItem
          }
          this.formTemplate = !this.formTemplate
        })
        .catch((err) => {
          this.formTemplate = !this.formTemplate
          console.log(err)
        })
    },
    async updatePage(p) {
      this.paramAPI.page = p
      this.paramAPI.offset = p - 1
      await this.getDataFromApi()
    },
    async updateItemPerPage(p) {
      this.paramAPI.itemsPerPage = p
      this.paramAPI.limit = p
      this.paramAPI.offset = 0
      await this.getDataFromApi()
    },
    convertDate(raw) {
      if (raw !== null) {
        const date = new Date(raw)
        const local = date.toLocaleString('id')
        return local
      } else {
        return '-'
      }
    }
  }
}
</script>
<style lang="scss">
#formTemplateList {
  position: relative;
  .form-template-list-div {
    padding: 15px;
    min-height: 50vh;
    display: flex;
    justify-content: center;
    align-items: center;

    .group-list-toolbar-1 {
      .group-list-toolbar-1 {
        width: 60%;
        display: flex;
        flex-direction: row;
        margin-left: auto;
      }
    }
    .form-template-list-toolbar2 {
      display: none;
    }
  }
}

@media (max-width: 768px) {
  #formTemplateList {
    .form-template-list-div {
      .group-list-toolbar-1 {
        .group-list-toolbar-1 {
          display: none;
        }
      }
      .form-template-list-toolbar2 {
        display: block;
      }
    }
  }
}
</style>
